import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CategoryModule } from './category.module';
platformBrowserDynamic().bootstrapModule(CategoryModule);
